import { Container } from "react-bootstrap";
import Header from "../Components/Header";

const ContactEN = () => {
  return (
    <>
      <Header />
      <Container style={{ paddingTop: 32 }}>
        <h1>Contáctenos</h1>
        <p style={{ paddingBottom: 24 }}>Si tiene alguna pregunta o sugerencia sobre la aplicación 52 Semanas, no dude en ponerse en contacto conmigo en <a href="mailto:contato@crjlab.com">contato@crjlab.com</a>.</p>
      </Container>
    </>
  );
}

export default ContactEN;